@if (_header) {
    <span class="lg-help-info-popup__header">{{ _header }}</span>
}
@if (description) {
    <span class="lg-help-info-popup__description" [innerHTML]="_sanitizedDescription"> </span>
}
<ng-template cdkPortalOutlet #outlet></ng-template>
@if (infoLinks) {
    <ul class="lg-help-info-popup__links">
        @for (link of infoLinks; track link) {
            <li class="lg-help-info-popup__links__item">
                <a [href]="link.url" target="_blank">
                    <lg-icon
                        class="lg-help-info-popup__links__item__icon"
                        [icon]="link.icon"
                        [inline]="true"
                    >
                    </lg-icon>
                    {{ link.text | lgTranslate }}
                </a>
            </li>
        }
    </ul>
}
